import { RequestDraftStatus } from '@prisma/client';

import { TrpcOutputs } from '../../config/trpc';

export type Draft = TrpcOutputs['getRequestDraft'];

export const statusColor: Record<RequestDraftStatus, string> = {
  Pending: 'blue',
  Approved: 'green',
  Discarded: 'gray',
};

/** ISO string from a draft payload → Date for date pickers (null when absent/invalid). */
export const toFormDate = (value?: string | null): Date | null => {
  if (!value) return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};
